import { TApplicationState } from '../../types/redux';

export function getUser(state: TApplicationState) {
  return state.user;
}
